import { render } from "./DashBoardFooter.vue?vue&type=template&id=397c0da4"
import script from "./DashBoardFooter.vue?vue&type=script&lang=js"
export * from "./DashBoardFooter.vue?vue&type=script&lang=js"
script.render = render

export default script